import React from 'react';
import './FooterForm.css'; // Importando o arquivo CSS

const FooterForm = () => {
  return (
    <footer className="footer">
      <p className="footer-text">
        Powered by <a href="https://www.instagram.com/_yorbit/" target="_blank" rel="noopener noreferrer" className="footer-link">yOrbit</a>
      </p>
    </footer>
  );
};

export default FooterForm;